// *********************************************************
// Route guard: allow access only for users with one of the allowed roles.
// Explicitly blocks Tele and Field users (by userFunction). Used to protect
// organizations, allocations, and profile from tele, field, legal, and lower roles.
// *********************************************************
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../_Services/user.service';

export const ROLES_ORGANIZATIONS_ALLOCATIONS_PROFILE = [
  'Admin',
  'EditGlobalDefaulters',
  'AssignInterOrg',
  'EditOrgDefaulters',
  'AssignIntraOrg',
];

export const DEFAULT_REDIRECT = 'dashboard-v3';

@Injectable({ providedIn: 'root' })
export class RoleRouteGuardService implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean {
    const data = route.data;
    const allowedRoles: string[] = data['allowedRoles'] ?? ROLES_ORGANIZATIONS_ALLOCATIONS_PROFILE;
    const redirectTo: string = data['redirectTo'] ?? DEFAULT_REDIRECT;

    if (!this.userService.isLoggedIn()) {
      this.router.navigate(['/signin']);
      return false;
    }

    // Block Field (userFunction 2) and Tele/Telecaller (userFunction 3) from these routes
    if (this.userService.isFieldOrTeleUser()) {
      this.router.navigate([redirectTo]);
      return false;
    }

    const hasRole = allowedRoles.some((role) => this.userService.userHasRole(role));
    if (hasRole) {
      return true;
    }

    this.router.navigate([redirectTo]);
    return false;
  }
}
